import React from "react";
import { useUserContext } from "context/UserContext";
import AgentManagementBK from "layouts/BK/agent";
import AgentManagementCM from "layouts/CM/agent";
import { canUseManagerRouteSet, normalizeRoleLevel } from "utils/roleUtils";

function AgentManagements() {
  const { roleLevel } = useUserContext() || {};
  const numericRoleLevel = normalizeRoleLevel(roleLevel);
  if (canUseManagerRouteSet(numericRoleLevel) && numericRoleLevel <= 3) {
    return <AgentManagementBK />;
  }
  if (numericRoleLevel === 4 || numericRoleLevel === 5) {
    return <AgentManagementCM />;
  }
  return null;
}

export default AgentManagements;
